import {
  Box,
  Checkbox,
  darken,
  FormControlLabel,
  FormGroup,
  lighten,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";

function PingEscala({
  theme,
  styles,
  setFiltroPing,
  filtroPing,
  setCheckChanges,
}) {
  return (
    <Box sx={styles.boxOP}>
      <Stack direction="column">
        <Typography sx={styles.text}>Filtro de Status</Typography>
        <Typography sx={styles.textFine}>
          Selecione os status de ping que deseja exibir no mapa.
        </Typography>
      </Stack>
      <Stack justifyContent="center" alignItems="start" mt={2} gap={1}>
        <FormGroup
          sx={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={filtroPing.includes("up")}
                onChange={(e) => {
                  setFiltroPing((prev) =>
                    e.target.checked
                      ? Array.from(new Set([...prev, "up"]))
                      : prev.filter((l) => l !== "up"),
                  );
                  setCheckChanges(true);
                }}
              />
            }
            label={
              <Stack sx={styles.stackCheckBox}>
                <Box
                  sx={[
                    styles.boxEscalaCheckBox,
                    {
                      backgroundColor: theme.palette.color?.status?.up,
                      "&:hover": {
                        backgroundColor:
                          theme.palette.mode === "dark"
                            ? lighten(theme.palette.color?.status?.up, 0.5)
                            : darken(theme.palette.color?.status?.up, 0.3),
                      },
                    },
                  ]}
                />
                <Typography sx={styles.subtitle}>Up</Typography>
              </Stack>
            }
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={filtroPing.includes("down")}
                onChange={(e) => {
                  setFiltroPing((prev) =>
                    e.target.checked
                      ? Array.from(new Set([...prev, "down"]))
                      : prev.filter((l) => l !== "down"),
                  );
                  setCheckChanges(true);
                }}
              />
            }
            label={
              <Stack sx={styles.stackCheckBox}>
                <Box
                  sx={[
                    styles.boxEscalaCheckBox,
                    {
                      backgroundColor: theme.palette.color?.status?.down,
                      "&:hover": {
                        backgroundColor:
                          theme.palette.mode === "dark"
                            ? lighten(theme.palette.color?.status?.down, 0.5)
                            : darken(theme.palette.color?.status?.down, 0.3),
                      },
                    },
                  ]}
                />
                <Typography sx={styles.subtitle}>Down</Typography>
              </Stack>
            }
          />
        </FormGroup>
      </Stack>
    </Box>
  );
}

export default PingEscala;
